export const normalizePhone = value => {
  // Remove all non-digit characters
  let digits = (value || "").replace(/\D/g, "");

  // Trim to max 10 digits
  if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }

  if (digits.length === 10) {
    // Format: XXX-XXX-XXXX
    return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6,10)}`;
  } else {
    // Return the trimmed digits (unformatted) if not 10 digits
    return digits;
  }
};

export const normalizePhoneExt = value =>  {
  // Remove all non-digit characters except 'x' or 'ext' for extension
  const match = (value || "").match(/^([^\dx]*)(\d{10})(.*)$/i);
  if (match) {
    const phone = normalizePhone(match[2]);
    const extMatch = match[3].match(/(x|ext\.?)(\d+)/i);
    if (extMatch) {
      return `${phone} ext. ${extMatch[2]}`;
    }
    return phone;
  }
  return value;
};